import { Injectable } from "@angular/core";
import { AccountLookupService } from "../../lookup/model/impl/AccountLookupService";
import { BranchLookupService } from "../../lookup/model/impl/BranchLookupService";
import { ClientLookupService } from "../../lookup/model/impl/ClientLookupService";
import { UserLookupService } from "../../lookup/model/impl/UserLookupService";

import { AccountModelPrivatization } from "./AccountModelPrivatization";

import { ClientModelPrivatization } from "./ClientModelPrivatization";
import { ClientTraderModelPrivatization } from "./ClientTraderModelPrivatization";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class BasePrivatizationService {
  protected accountLookup: AccountLookupService;
  protected clientLookup: ClientLookupService;
  protected branchLookup: BranchLookupService;
  protected userLookup: UserLookupService;

  constructor(
    protected cmp: ClientModelPrivatization,
    protected amp: AccountModelPrivatization,
    protected ctmp: ClientTraderModelPrivatization,
  ) {}
  protected checkClientSegment(clientSegment: string) {
    if (!this.cmp.hasRestrictedClientSegment(clientSegment)) {
      let restrictedClient = this.clientLookup.getItem(this.cmp.getRestrictedKey());
      let restrictedClientContact = this.clientLookup.getClientContacts(
        this.cmp.getRestrictedKey(),
      )[0];
      let restrictedClientContactRestrictedKey = restrictedClientContact.id;

      this.cmp.addRestrictedClientSegment(
        clientSegment,
        this.cmp.getRestrictedKey(),
        restrictedClient,
        restrictedClientContactRestrictedKey,
        restrictedClientContact,
      );
    }
    if (!this.amp.hasRestrictedClientSegment(clientSegment)) {
      let restrictedAccount = this.accountLookup.getItem(this.amp.getRestrictedKey());

      this.amp.addRestrictedClientSegment(
        clientSegment,
        this.amp.getRestrictedKey(),
        restrictedAccount,
      );
    }
    if (!this.ctmp.hasRestrictedClientSegment(clientSegment)) {
      let restrictedClientTrader = this.userLookup.getItem(this.ctmp.getRestrictedKey());

      this.ctmp.addRestrictedClientSegment(
        clientSegment,
        this.ctmp.getRestrictedKey(),
        restrictedClientTrader,
      );
    }
  }

  protected checkIdName(
    clientId: string,
    clientName: string,
    accountId: string,
    accountName: string,
  ) {
    if (!this.cmp.hasRestrictedIdName(clientId, clientName)) {
      let restrictedClient = this.clientLookup.getItem(this.cmp.getRestrictedKey());

      this.cmp.addRestrictedIdName(
        clientId,
        clientName,
        this.cmp.getRestrictedKey(),
        restrictedClient,
      );
    }
    if (!this.amp.hasRestrictedIdName(accountId, accountName)) {
      let restrictedAccount = this.accountLookup.getItem(this.amp.getRestrictedKey());

      this.amp.addRestrictedIdName(
        accountId,
        accountName,
        this.amp.getRestrictedKey(),
        restrictedAccount,
      );
    }
  }

  protected privatizeCounterPartyDetails(
    cpd: CubiqTS.CounterPartyDetails,
    label: string,
    privatizedContactId: CubiqTS.Long,
  ): any {
    if (!cpd) {
      return cpd;
    }

    if (cpd.account instanceof CubiqTS.AccountImpl) {
      cpd.account = this.privatizeConcreteEncodable(cpd.account, label);
    }

    if (cpd.client instanceof CubiqTS.ClientImpl) {
      cpd.client = this.privatizeClient(cpd.client, label);
    }

    if (Array.isArray(cpd.contacts)) {
      cpd.contacts.forEach((contact, i, arr) => {
        arr[i] = this.privatizeConcreteEncodable(contact, label);
        arr[i].id = privatizedContactId;
      });
    }

    return cpd;
  }

  protected privatizeConcreteEncodable(model: CubiqTS.ConcreteEncodable, label: string): any {
    if (!model || !(model instanceof CubiqTS.ConcreteEncodable)) return model;

    for (let key of Object.keys(model)) {
      if (key == "messageId") continue;
      if (key == "encodableType") {
        continue;
      }
      if (key == "enType") {
        continue;
      }

      if (typeof model[key] == "string" && model[key].length > 0) {
        model[key] = label;
      }
    }

    return model;
  }

  protected privatizeClient(model: CubiqTS.ClientImpl, label: string): CubiqTS.ClientImpl {
    model = this.privatizeConcreteEncodable(model, label);
    model.salesGroupId = new CubiqTS.Long(-1);

    return model;
  }
}
